import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import './styles.css';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Providers } from './app-providers.jsx';
import { App } from './app.jsx';

hydrateRoot(document.getElementById('root'), <Providers><BrowserRouter><App /></BrowserRouter></Providers>);
